<template>
  <h3 class="py-3">Contributors</h3>
  <div class="row g-1">
    <div class="col-3 col-sm-2 col-md-1" v-for="item in contribs" :key="item.id">
      <img class="mx-auto d-block" :src="item.avatar" alt="" />
      <p class="text-center mt-2">{{item.name}}</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      contribs: [
        {
          name: 'Blues',
          avatar: 'images/contrib/blues.png'
        },
        {
          name: 'Doub1ex',
          avatar: 'images/contrib/doub1ex.png'
        },
        {
          name: '黄月月不要牙疼🌟🎀',
          avatar: 'images/contrib/hyy.png'
        },
        {
          name: '萬事屋',
          avatar: 'images/contrib/wsw.png'
        },
        {
          name: '序曲',
          avatar: 'images/contrib/xq.png'
        },
        {
          name: '媛媛酱',
          avatar: 'images/contrib/yyj.png'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  width: 3rem;
  border-radius: 50%;
}
p{ font-size: .65rem;}

</style>
